module.exports = __webpack_public_path__ + "static/media/paragon_4.8119b392.jpg";